<template>
    <div class="body_main">
        <div class="count_body_bd">
            <!-- 今日预约统计面板 -->
            <div class="today_panel">
                <!-- 左侧：日期标题区 -->
                <div class="today_panel_left" :class="{ today_panel_left_active: !queryParams.reStatus && !queryParams.isFree }" @click="filterByStatus('')">
                    <div class="today_panel_icon">
                        <el-icon size="28"><Calendar /></el-icon>
                    </div>
                    <div class="today_panel_title">
                        <div class="today_main_title">今日预约</div>
                        <div class="today_sub_title">{{ todayLabel }}</div>
                    </div>
                    <div class="today_divider"></div>
                    <div class="today_total_block">
                        <span class="today_total_num">{{ statData.total }}</span>
                        <span class="today_total_label">总预约数</span>
                    </div>
                </div>

                <!-- 右侧：统计卡片区 -->
                <div class="today_panel_right">
                    <div class="stat_card stat_card_wait_sign" :class="{ stat_card_active: queryParams.reStatus === '8' }" @click="filterByStatus('8')">
                        <div class="stat_card_icon">
                            <el-icon size="20"><Clock /></el-icon>
                        </div>
                        <div class="stat_card_info">
                            <span class="stat_num">{{ statData.waitSign }}</span>
                            <span class="stat_label">待签到</span>
                        </div>
                    </div>
                    <div class="stat_card stat_card_wait_visit" :class="{ stat_card_active: queryParams.reStatus === '5' }" @click="filterByStatus('5')">
                        <div class="stat_card_icon">
                            <el-icon size="20"><UserFilled /></el-icon>
                        </div>
                        <div class="stat_card_info">
                            <span class="stat_num">{{ statData.waitVisit }}</span>
                            <span class="stat_label">待就诊</span>
                        </div>
                    </div>
                    <div class="stat_card stat_card_visiting" :class="{ stat_card_active: queryParams.reStatus === '6' }" @click="filterByStatus('6')">
                        <div class="stat_card_icon">
                            <el-icon size="20"><FirstAidKit /></el-icon>
                        </div>
                        <div class="stat_card_info">
                            <span class="stat_num">{{ statData.visiting }}</span>
                            <span class="stat_label">就诊中</span>
                        </div>
                    </div>
                    <div class="stat_card stat_card_done" :class="{ stat_card_active: queryParams.reStatus === '2' }" @click="filterByStatus('2')">
                        <div class="stat_card_icon">
                            <el-icon size="20"><CircleCheck /></el-icon>
                        </div>
                        <div class="stat_card_info">
                            <span class="stat_num">{{ statData.done }}</span>
                            <span class="stat_label">已完成</span>
                        </div>
                    </div>
                    <div class="stat_card stat_card_cancel" :class="{ stat_card_active: queryParams.isFree === '1' }" @click="filterByStatus('', '1')">
                        <div class="stat_card_icon">
                            <el-icon size="20"><CircleClose /></el-icon>
                        </div>
                        <div class="stat_card_info">
                            <span class="stat_num">{{ statData.cancel }}</span>
                            <span class="stat_label">已取消/失效</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="queue_panel">
            <div class="queue_panel_title">统一接诊队列</div>
            <el-skeleton v-if="queueLoading" :rows="1" animated />
            <el-space v-else wrap>
                <el-tag v-for="(item, index) in queueData" :key="item.queueType + '-' + item.id" :type="item.queueType === 'RETURN' ? 'warning' : (item.registrationSource === 'ONSITE' ? 'info' : 'success')">
                    {{ index + 1 }}. {{ item.doctorName ? item.doctorName + ' · ' : '' }}{{ item.queueNoText }}{{ item.patientName || '患者' }}{{ item.queueType === 'RETURN' && item.visitType ? ' · ' + item.visitType : '' }}
                    <!-- 叫号统一在 clinic 门诊端操作，收费端队列只读；仅保留回诊的完成/取消 -->
                    <template v-if="item.queueType === 'RETURN' && item.status === 'CALLED'">
                        <el-button link type="success" @click="handleQueueAction(item, 'complete')">完成</el-button>
                        <el-button link type="danger" @click="handleQueueAction(item, 'cancel')">取消</el-button>
                    </template>
                </el-tag>
                <span v-if="!queueData.length" class="queue_empty">暂无待接诊患者</span>
            </el-space>
        </div>
        <div class="table_body_bd">
            <!-- 搜索 -->
            <el-form class="search_con" :model="queryParams" ref="queryForm" :inline="true" label-width="68px" @submit.prevent="getTodayReservationListInfo">
                <el-form-item label="预约人">
                    <el-input
                        v-model="queryParams.cardPatientName"
                        placeholder="预约人（模糊搜索）"
                        clearable
                    />
                </el-form-item>
                <el-form-item label="手机号">
                    <el-input
                        v-model="queryParams.cardPatientPhone"
                        placeholder="手机号（模糊搜索）"
                        clearable
                    />
                </el-form-item>
                <el-form-item label="预约单号">
                    <el-input
                        v-model="queryParams.reSerialNo"
                        placeholder="预约单号（模糊搜索）"
                        clearable
                    />
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="Search" native-type="submit">搜索</el-button>
                    <el-button icon="Refresh" @click="resetQuery">重置</el-button>
                    <!-- 现场挂号：现场填写患者信息，占线上号源或排到最后 -->
                    <el-button class="onsite_entry_btn" type="success" icon="Plus" @click="openOnsiteDialog">现场挂号</el-button>
                </el-form-item>
            </el-form>

            <!-- 表格 -->
            <div class="table_bd">
                <el-table
                    ref="multipleTable"
                    v-loading="tableLoading"
                    :data="tableData"
                    :max-height="tableHeight"
                    style="width: 100%">
                    <template #empty>
                        <el-empty :image-size="120"></el-empty>
                    </template>
                    <el-table-column type="index" label="序号" width="50"> </el-table-column>
                    <el-table-column
                        prop="reSerialNo"
                        label="预约单号">
                    </el-table-column>
                    <el-table-column
                        label="预约人">
                        <template #default="scope">
                            <div class="base_con">
                                <el-image class="elImage" :src="scope.row.avatar"></el-image>
                                <div class="base_info">
                                    <span style="font-size: 16px; font-weight: 600; line-height: 24px">{{ scope.row.cardPatientName }}</span>
                                    <span style="font-size: 14px; color:#aaa; line-height: 24px">{{ scope.row.sexText }}  {{ scope.row.age }}岁</span>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="预约人手机号">
                        <template #default="scope">
                            <span>{{ scope.row.cardPatientPhone === null ? '---' : scope.row.cardPatientPhone }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="预约预计时间"
                        width="180">
                        <template #default="scope">
                            <span style="font-size: 14px; font-weight: 600">{{ scope.row.reTime ? scope.row.reTime.slice(0, 16) : '---' }} {{scope.row.reTimeTypeText}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="预约号"
                        width="90">
                        <template #default="scope">
                            <!-- 排队号由签到/现场挂号/收款成功时分配（当天顺序），未进队列显示 --- -->
                            <span style="font-size: 14px; font-weight: 600">{{ scope.row.queueSeq ? scope.row.queueSeq + '号' : '---' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="预约单类型"
                        width="120">
                        <template #default="scope">
                            <el-tag :type="scope.row.visitType === null || scope.row.visitType === '初诊'?'success':'warning'" disable-transitions>
                                {{ scope.row.visitType === null ? '初诊' : scope.row.visitType }}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="预约单状态"
                        width="120">
                        <template #default="scope">
                            <el-tag
                                :type="scope.row.reStatus === '5' ? 'success' : scope.row.reStatus === '6' ? '' :
                                scope.row.reStatus === '7' ? 'danger' : scope.row.reStatus === '8' ? 'warning' :
                                scope.row.reStatus === '4' ? 'info' : scope.row.reStatus === '3' ? 'danger' :
                                scope.row.reStatus === '1' ? 'danger' : ''"
                                disable-transitions>{{ scope.row.reStatusText }}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="预约医生">
                        <template #default="scope">
                            <span>{{ scope.row.doctorName === null ? '---' : scope.row.doctorName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="门诊科室">
                        <template #default="scope">
                            <span>{{ scope.row.odName === null ? '---' : scope.row.odName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="createTime"
                        label="创建时间">
                    </el-table-column>
                    <el-table-column
                        fixed="right"
                        label="操作"
                        width="130">
                        <template #default="scope">
                            <el-button type="warning" size="small" @click="handleSign(scope.row)" v-if="scope.row.reStatus === '8'">签到</el-button>
                            <el-button type="success" size="small" @click="handleReturnVisit(scope.row)" v-if="scope.row.reStatus === '2' || scope.row.reStatus === '7'">回诊</el-button>
                            <!-- 查询收款结果：弹窗关闭后仍能补查（只读查单，绝不发起扣款） -->
                            <el-button type="primary" size="small" @click="queryListPayResult(scope.row)" v-if="scope.row.reStatus === '1'">查询收款结果</el-button>
                            <span v-if="scope.row.reStatus !== '8' && scope.row.reStatus !== '2' && scope.row.reStatus !== '7' && scope.row.reStatus !== '1'">—</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <!-- 分页 -->
            <div class="table_pagination">
                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-size="pageNums"
                    layout="prev, pager, next, total, sizes"
                    :total="totalCount">
                </el-pagination>
            </div>
        </div>

        <!-- 现场挂号：参考小程序挂号，现场选医生+场次并填写患者信息；免费/付费两入口 -->
        <el-dialog
            v-model="onsiteDialog.visible"
            title="现场挂号"
            width="520px"
            :close-on-click-modal="false"
            :show-close="!onsitePayDialogLocked"
            :close-on-press-escape="!onsitePayDialogLocked"
            :before-close="handleOnsiteDialogClose"
            @closed="resetOnsiteForm">
            <!-- 第一步：挂号表单（免费/付费共用） -->
            <el-form ref="onsiteFormRef" :model="onsiteForm" :rules="onsiteRules" label-width="88px" v-loading="onsiteLoading" v-if="onsitePay.step === 'form'">
                <el-form-item label="医生" prop="doctorId">
                    <el-select
                        v-model="onsiteForm.doctorId"
                        placeholder="请选择医生"
                        filterable
                        style="width: 100%"
                        @change="handleOnsiteDoctorChange">
                        <el-option
                            v-for="doc in onsiteDoctors"
                            :key="doc.doctorId"
                            :label="doc.docName + (doc.odName ? '（' + doc.odName + '）' : '')"
                            :value="doc.doctorId" />
                    </el-select>
                </el-form-item>
                <el-form-item label="场次" prop="slotKey">
                    <el-select
                        v-model="onsiteForm.slotKey"
                        :placeholder="!onsiteForm.doctorId ? '请先选择医生' : onsiteOpenSlots.length > 0 ? '请选择场次' : '当天已无可挂号源'"
                        :disabled="!onsiteForm.doctorId || onsiteOpenSlots.length === 0"
                        style="width: 100%">
                        <el-option
                            v-for="slot in onsiteOpenSlots"
                            :key="slot.key"
                            :label="slot.label"
                            :value="slot.key" />
                    </el-select>
                </el-form-item>
                <div v-if="onsiteForm.doctorId && onsiteOpenSlots.length === 0" class="onsite_tip onsite_tip_warn">
                    该医生当天场次都已约满或已结束，没有可挂的号源：挂号后会排到队列最后，号数接着线上编号。
                </div>
                <!-- 已有患者搜索：类似门诊开方的患者输入框，选中后复用档案；不选则按下方手填信息匹配/新建档案 -->
                <el-form-item label="已有患者">
                    <div class="onsite_patient_search">
                        <el-input
                            v-model="onsitePatientKeyword"
                            placeholder="输入姓名或手机号搜索已有档案，点击选中自动回填；不选则按下方信息新建档案"
                            clearable
                            @input="handleOnsitePatientInput"
                            @focus="handleOnsitePatientFocus"
                            @blur="handleOnsitePatientBlur" />
                        <div class="name_select_con" v-if="onsitePatientDropdownShow && onsitePatientOptions.length > 0">
                            <div class="name_select_li" v-for="item in onsitePatientOptions" :key="item.patientId"
                                 @mousedown.prevent @click="chooseOnsitePatient(item)">
                                <span class="onsite_patient_name">{{ item.name }}</span>
                                <span class="onsite_patient_meta">{{ item.sexText }}<template v-if="item.age !== null && item.age !== undefined && item.age !== ''"> {{ item.age }}岁</template><template v-if="item.identity">　{{ item.identity }}</template><template v-if="item.phoneNumber">　{{ item.phoneNumber }}</template></span>
                            </div>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="姓名" prop="cardPatientName">
                    <el-input v-model="onsiteForm.cardPatientName" placeholder="患者姓名" maxlength="20" :disabled="!!onsiteForm.cardId" />
                </el-form-item>
                <el-form-item label="身份证号" prop="cardIdentity">
                    <el-input v-model="onsiteForm.cardIdentity" placeholder="用于匹配已有档案" maxlength="18" :disabled="!!onsiteForm.cardId" />
                </el-form-item>
                <el-form-item label="手机号" prop="cardPatientPhone">
                    <el-input v-model="onsiteForm.cardPatientPhone" placeholder="患者手机号" maxlength="11" :disabled="!!onsiteForm.cardId" />
                </el-form-item>
                <el-form-item v-if="onsiteForm.cardId">
                    <el-button link type="warning" @click="clearOnsitePatient">清除已选患者，改回手填</el-button>
                </el-form-item>
                <div class="onsite_tip">
                    提交前会先按身份证号在已有档案里匹配：匹配到会弹窗列出全部同名下档案（同一人可能在多个账号名下各有一条），选中某条档案提交或更新后再提交，也可使用手填信息新建档案；匹配不到才按上面填写的信息自动建档。已通过上方搜索选中档案时，挂号信息以档案为准（下方输入框锁定）。现场挂号占该场次的线上号源，按号排队。
                </div>
            </el-form>

            <!-- 第二步：费用确认（付费挂号） -->
            <div v-else-if="onsitePay.step === 'charge'" v-loading="onsitePay.submitting">
                <div class="onsite_charge_summary">
                    <div class="pay_info_item flex_c_between">
                        <div class="pay_info_item_left">患者姓名：</div>
                        <div class="pay_info_item_right">{{ onsiteForm.cardPatientName || '—' }}</div>
                    </div>
                    <div class="pay_info_item flex_c_between">
                        <div class="pay_info_item_left">医生：</div>
                        <div class="pay_info_item_right">{{ onsiteDoctorLabel }}</div>
                    </div>
                </div>
                <el-form label-width="88px">
                    <el-form-item label="挂号费">
                        <el-radio-group v-model="onsitePay.feeMode">
                            <el-radio label="doctor" :disabled="!onsiteDoctorFee || onsiteDoctorFee <= 0">
                                按医生设置{{ onsiteDoctorFee && onsiteDoctorFee > 0 ? '（￥' + onsiteDoctorFee + '）' : '（未设置）' }}
                            </el-radio>
                            <el-radio label="custom">自定义金额</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item v-if="onsitePay.feeMode === 'custom'" label="金额（元）">
                        <el-input v-model="onsitePay.customAmount" placeholder="0.01 ~ 99999.99" maxlength="9" style="width: 200px" />
                    </el-form-item>
                </el-form>
                <div class="onsite_tip">
                    确认后创建待支付挂号单并进入扫码收款；患者支付成功后自动进队列（无需签到）。关闭窗口或放弃支付会自动取消该单并释放号源。
                </div>
            </div>

            <!-- 第三步：扫码收款（付费挂号，结构对齐检查治疗单收费） -->
            <div v-else-if="onsitePay.step === 'scan'" class="pay_content flex_c_col">
                <div class="pay_main_body flex_t_col">
                    <!--等待扫码-->
                    <div class="pay_screen_con flex_c_col" v-if="onsitePay.isWaitPayLoading && !onsitePay.payLoading && !onsitePay.isPayed">
                        <el-icon class="pay_screen_icon">
                            <Connection />
                        </el-icon>
                        <div class="pay_screen_text">正在等待扫码中，请稍候...</div>
                    </div>
                    <!--加载圈-->
                    <div class="pay_loading_con flex_c_col" v-if="onsitePay.isWaitPayLoading && onsitePay.payLoading && !onsitePay.isPayed">
                        <el-icon class="pay_loading_icon is-loading">
                            <loading />
                        </el-icon>
                        <div class="pay_loading_text">正在等待订单支付，请稍候...</div>
                        <div class="pay_loading_text" v-if="onsitePayDialogLocked">查询支付结果中，请勿关闭弹窗</div>
                    </div>
                    <!-- 订单信息-->
                    <div class="pay_order_main" v-if="onsitePay.isWaitPayLoading && !onsitePay.isPayed">
                        <div class="pay_info_item flex_c_between">
                            <div class="pay_info_item_left">患者信息：</div>
                            <div class="pay_info_item_right">{{ onsitePay.patientName }}</div>
                        </div>
                        <div class="pay_info_item flex_c_between">
                            <div class="pay_info_item_left">医生：</div>
                            <div class="pay_info_item_right">{{ onsitePay.doctorName }}</div>
                        </div>
                        <div class="pay_info_item flex_c_between">
                            <div class="pay_info_item_left">挂号单号：</div>
                            <div class="pay_info_item_right">{{ onsitePay.reSerialNo }}</div>
                        </div>
                        <div class="pay_info_title">支付信息</div>
                        <div class="pay_info_item flex_c_between">
                            <div class="pay_info_item_left">挂号费：</div>
                            <div class="pay_info_item_right font_weight font_orange font_28">￥{{ onsitePay.amount }}</div>
                        </div>
                        <div class="pay_warning_info flex_t_col">
                            <div class="pay_warning_li">*特殊说明：</div>
                            <div class="pay_warning_li">①请仔细核对患者与费用信息，避免错误收费。</div>
                            <div class="pay_warning_li">②请患者打开移动付款码放置扫码盒子上或使用扫码枪扫患者的付款二维码，完成支付。</div>
                        </div>
                    </div>
                    <!-- 订单结果-->
                    <div class="pay_order_main" v-if="!onsitePay.isWaitPayLoading && onsitePay.isPayed">
                        <div class="pay_order_success flex_c_col">
                            <el-icon class="pay_order_success_icon font_green" v-if="onsitePay.payState === 'success'">
                                <SuccessFilled />
                            </el-icon>
                            <el-icon class="pay_order_success_icon font_orange" v-if="onsitePay.payState === 'pending'">
                                <WarningFilled />
                            </el-icon>
                            <el-icon class="pay_order_success_icon font_red" v-if="onsitePay.payState === 'failed'">
                                <CircleCloseFilled />
                            </el-icon>
                            <div class="pay_order_success_text flex_c font_16"><span class="font_gold mrlr10 font_18">{{ onsitePay.patientName }}</span>
                                的挂号单{{ onsitePayResultText }}</div>
                            <div class="pay_order_error_text flex_c font_14" v-if="onsitePay.payState !== 'success' && onsitePay.payErrorMsg"
                                 :style="{color: onsitePay.payState === 'pending' ? '#e6a23c' : '#f56c6c', margin: '8px 0'}">{{ onsitePay.payErrorMsg }}</div>
                            <div class="pay_info_item flex_c_between" v-if="onsitePay.payState === 'success' && onsitePay.queueSeq">
                                <div class="pay_info_item_left">排队号：</div>
                                <div class="pay_info_item_right font_weight font_orange">{{ onsitePay.queueSeq }}号</div>
                            </div>
                            <div class="pay_info_item flex_c_between">
                                <div class="pay_info_item_left">挂号单号：</div>
                                <div class="pay_info_item_right font_weight">{{ onsitePay.reSerialNo }}</div>
                            </div>
                            <div class="pay_info_item flex_c_between">
                                <div class="pay_info_item_left">挂号费：</div>
                                <div class="pay_info_item_right font_weight font_orange font_28">￥{{ onsitePay.amount }}</div>
                            </div>
                            <div class="pay_warning_info flex_t_col">
                                <div class="pay_warning_li">*特殊说明：</div>
                                <div class="pay_warning_li" v-if="onsitePayDialogLocked">查询支付结果中，请勿关闭弹窗。</div>
                                <div class="pay_warning_li" v-if="onsitePay.payState === 'pending'">①支付结果尚未确认，请勿重复扫码，点击「重新查询」确认结果。</div>
                                <div class="pay_warning_li" v-else>①若支付失败，请重新扫患者的付款二维码进行扫码支付。</div>
                                <div class="pay_warning_li">②支付成功后患者自动进入就诊队列，无需签到。</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <template #footer>
                <template v-if="onsitePay.step === 'form'">
                    <el-button @click="handleOnsiteDialogClose">取消</el-button>
                    <el-button type="primary" :loading="onsiteDialog.submitting" @click="submitOnsite">免费挂号</el-button>
                    <el-button type="success" @click="startOnsiteCharge">付费挂号</el-button>
                </template>
                <template v-else-if="onsitePay.step === 'charge'">
                    <el-button :disabled="onsitePay.submitting" @click="onsitePay.step = 'form'">上一步</el-button>
                    <el-button type="primary" :loading="onsitePay.submitting" @click="confirmOnsiteCharge">确认并扫码收款</el-button>
                </template>
                <template v-else>
                    <el-button type="warning" :loading="onsitePay.querying" v-if="onsitePay.isPayed && onsitePay.payState === 'pending'" @click="requeryOnsitePayResult()">重新查询</el-button>
                    <el-button type="danger" v-if="onsitePay.isPayed && onsitePay.payState === 'failed'" @click="onsiteRetryScan">刷新重试</el-button>
                    <el-button type="info" @click="handleOnsiteDialogClose">取消</el-button>
                </template>
            </template>
        </el-dialog>

        <!-- 手填身份证匹配确认：命中已有档案时列出全部候选（同人多副本），操作员单选具体档案后提交/更新/新建；取消则留在表单页不提交 -->
        <el-dialog
            v-model="onsiteMatch.visible"
            title="匹配到已有患者档案"
            width="560px"
            append-to-body
            :close-on-click-modal="false"
            @close="handleOnsiteMatchClose">
            <div class="onsite_match_tip">
                手填身份证号已匹配到 {{ onsiteMatch.matchedList.length }} 条已有患者档案（同一人可能在多个小程序账号名下各有一条），请核对并选择要使用的档案：
            </div>
            <el-radio-group v-model="onsiteMatch.selectedId" class="onsite_match_list">
                <el-radio
                    v-for="item in onsiteMatch.matchedList"
                    :key="item.patientId"
                    :label="item.patientId"
                    class="onsite_match_item">
                    <div class="onsite_match_row">
                        <span class="font_weight">{{ item.name || '—' }}</span>
                        <span>{{ item.phoneNumber || '手机号未填' }}</span>
                        <span v-if="item.familyRelation">（{{ item.familyRelation }}）</span>
                        <span v-if="item.age">{{ item.age }}岁</span>
                    </div>
                </el-radio>
            </el-radio-group>
            <div class="onsite_match_diff" v-if="onsiteMatchSelected && onsiteForm.cardPatientName.trim() && onsiteForm.cardPatientName.trim() !== onsiteMatchSelected.name">
                注意：手填姓名「{{ onsiteForm.cardPatientName.trim() }}」与选中档案姓名「{{ onsiteMatchSelected.name || '—' }}」不一致。
            </div>
            <div class="onsite_match_diff" v-if="onsiteMatchSelected && onsiteForm.cardPatientPhone.trim() && onsiteForm.cardPatientPhone.trim() !== (onsiteMatchSelected.phoneNumber || '')">
                注意：手填手机号与选中档案手机号不一致。
            </div>
            <template #footer>
                <div class="onsite_match_footer">
                    <el-button @click="handleOnsiteMatchClose">取消</el-button>
                    <el-button @click="chooseOnsiteMatchAction('create')">使用手填档案新建</el-button>
                    <el-button type="warning" :disabled="!onsiteMatch.selectedId" @click="chooseOnsiteMatchAction('update')">更新选中档案提交</el-button>
                    <el-button type="primary" :disabled="!onsiteMatch.selectedId" @click="chooseOnsiteMatchAction('reuse')">使用选中档案</el-button>
                </div>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import todayreservation from "@/assets/scripts/todayreservation/index";

export default todayreservation;
</script>

<style scoped>
/* 收款面板样式（.pay_screen_con / .pay_info_item / .pay_order_main 等）在全局 style.scss，同 treatorder 做法 */
@import "@/assets/styles/style.scss";

 .queue_panel {
    margin: 0 0 16px;
    padding: 16px 20px;
    background: #fff;
    border: 1px solid #e8efff;
    border-radius: 12px;
 }
 .queue_panel_title { font-weight: 600; margin-bottom: 10px; color: #303133; }
 .queue_empty { color: #909399; }
/* ===== 今日预约统计面板 ===== */
/* 现场挂号入口：与搜索/重置拉开距离，避免误点 */
.onsite_entry_btn {
    margin-left: 16px;
}

.onsite_tip {
    margin: 0 0 4px 88px;
    padding: 8px 12px;
    font-size: 12px;
    line-height: 18px;
    color: #909399;
    background: #f5f7fa;
    border-radius: 4px;
}

/* 没有可挂号源时的提示：要让人一眼看到会排到最后 */
.onsite_tip_warn {
    margin-bottom: 16px;
    color: #e6a23c;
    background: #fdf6ec;
}

/* 付费挂号费用确认页的患者/医生摘要 */
.onsite_charge_summary {
    margin-bottom: 16px;
    padding: 12px 16px;
    background: #f7faff;
    border-radius: 6px;
}

/* 已有患者搜索容器：全局下拉 .name_select_con 是 absolute 定位，父容器必须 relative */
.onsite_patient_search {
    position: relative;
    width: 100%;
}

/* 匹配确认弹窗：候选档案单选列表 + 差异提醒（append-to-body 弹到 body，样式随 scoped 属性仍生效） */
.onsite_match_tip {
    font-size: 14px;
    color: #303133;
    margin-bottom: 12px;
}

.onsite_match_list {
    display: block;
    width: 100%;
}

.onsite_match_item {
    display: flex;
    align-items: center;
    width: 100%;
    margin: 0;
    padding: 8px 12px;
    background: #f7faff;
    border-radius: 6px;
}

.onsite_match_item + .onsite_match_item {
    margin-top: 6px;
}

.onsite_match_row {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 14px;
    color: #606266;
}

/* 弹窗底部按钮排：flex 右对齐 + 允许换行，放不下时换到第二行右对齐而不是溢出错位 */
.onsite_match_footer {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 10px;
}

/* 间距统一交给 gap，去掉 el-button 相邻默认 margin（否则换行后左右间距不一致） */
.onsite_match_footer .el-button + .el-button {
    margin-left: 0;
}

.onsite_match_diff {
    margin-top: 10px;
    font-size: 13px;
    line-height: 18px;
    color: #e6a23c;
}

.onsite_patient_name {
    font-weight: 600;
}

.onsite_patient_meta {
    color: #909399;
    font-size: 13px;
    margin-left: 10px;
}

.today_panel {
    display: flex;
    align-items: stretch;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(64, 128, 255, 0.10);
    margin-bottom: 16px;
    overflow: hidden;
    border: 1px solid #e8efff;
    min-height: 96px;
}

/* 左侧标题区 */
.today_panel_left {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 20px 28px;
    background: linear-gradient(135deg, #4080ff 0%, #73a7ff 100%);
    min-width: 320px;
    flex-shrink: 0;
    cursor: pointer;
    transition: box-shadow 0.2s, filter 0.2s;
}

.today_panel_left:hover {
    filter: brightness(1.04);
}

.today_panel_left_active {
    box-shadow: inset 0 0 0 2px rgba(255, 255, 255, 0.42);
}

.today_panel_icon {
    width: 52px;
    height: 52px;
    background: rgba(255, 255, 255, 0.22);
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    flex-shrink: 0;
}

.today_panel_title {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.today_main_title {
    font-size: 20px;
    font-weight: 700;
    color: #fff;
    line-height: 1.2;
    letter-spacing: 1px;
}

.today_sub_title {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.82);
}

.today_divider {
    width: 1px;
    height: 40px;
    background: rgba(255, 255, 255, 0.30);
    flex-shrink: 0;
    margin: 0 4px;
}

.today_total_block {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2px;
}

.today_total_num {
    font-size: 32px;
    font-weight: 800;
    color: #fff;
    line-height: 1;
}

.today_total_label {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.80);
    letter-spacing: 1px;
}

/* 右侧统计卡片区 */
.today_panel_right {
    flex: 1;
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 16px 24px;
    background: #f7faff;
}

.stat_card {
    flex: 1;
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 14px 16px;
    border-radius: 10px;
    background: #fff;
    border: 1.5px solid transparent;
    box-shadow: 0 1px 4px rgba(0,0,0,0.06);
    transition: box-shadow 0.2s, transform 0.2s;
    cursor: pointer;
    min-width: 0;
}

.stat_card:hover {
    box-shadow: 0 4px 14px rgba(0,0,0,0.10);
    transform: translateY(-2px);
}

.stat_card_active {
    position: relative;
    border-color: var(--card-color);
    background: var(--card-color);
    box-shadow: 0 5px 16px rgba(31, 45, 61, 0.18);
    transform: translateY(-1px);
}

.stat_card_active::after {
    position: absolute;
    top: 8px;
    right: 9px;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.92);
    content: '';
}

.stat_card_active .stat_card_icon {
    background: rgba(255, 255, 255, 0.22);
    color: #fff;
}

.stat_card_active .stat_num,
.stat_card_active .stat_label {
    color: #fff !important;
}

.stat_card_icon {
    width: 38px;
    height: 38px;
    border-radius: 9px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.stat_card_info {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
}

.stat_num {
    font-size: 22px;
    font-weight: 700;
    line-height: 1;
}

.stat_label {
    font-size: 11px;
    color: #999;
    white-space: nowrap;
    letter-spacing: 0.5px;
}

/* 各状态卡片色调 */
.stat_card_wait_sign {
    --card-color: #f07800;
    border-color: #fff3e6;
}
.stat_card_wait_sign .stat_card_icon {
    background: #fff3e6;
    color: #f07800;
}
.stat_card_wait_sign .stat_num {
    color: #f07800;
}

.stat_card_wait_visit {
    --card-color: #1677ff;
    border-color: #e6f4ff;
}
.stat_card_wait_visit .stat_card_icon {
    background: #e6f4ff;
    color: #1677ff;
}
.stat_card_wait_visit .stat_num {
    color: #1677ff;
}

.stat_card_visiting {
    --card-color: #00b96b;
    border-color: #e6fff0;
}
.stat_card_visiting .stat_card_icon {
    background: #e6fff0;
    color: #00b96b;
}
.stat_card_visiting .stat_num {
    color: #00b96b;
}

.stat_card_done {
    --card-color: #4080ff;
    border-color: #f0f5ff;
}
.stat_card_done .stat_card_icon {
    background: #f0f5ff;
    color: #4080ff;
}
.stat_card_done .stat_num {
    color: #4080ff;
}

.stat_card_cancel {
    --card-color: #cf1322;
    border-color: #fff1f0;
}
.stat_card_cancel .stat_card_icon {
    background: #fff1f0;
    color: #cf1322;
}
.stat_card_cancel .stat_num {
    color: #cf1322;
}
</style>
